import { render, staticRenderFns } from "./miniGauge.vue?vue&type=template&id=38dc57ed&"
import script from "./miniGauge.vue?vue&type=script&lang=js&"
export * from "./miniGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports